import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconBotNoData100pxBoldLightS = function IconBotNoData100pxBoldLightS(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 100 100",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M85.406 54.914l-1.599-.392-.583 1.995a7.381 7.381 0 00-.899 1.948 6.958 6.958 0 00-.31 2.19l-.539 1.844 1.42.348c.127.087.265.15.415.185 1.215.29 2.742-1.285 3.412-3.518.67-2.232.229-4.277-.986-4.567a1.283 1.283 0 00-.33-.033z",
      fill: "#6E727D"
    }), /*#__PURE__*/_jsx("rect", {
      x: "42.968",
      y: "36.019",
      width: "45.582",
      height: "27.055",
      rx: "13.528",
      transform: "rotate(11.655 42.968 36.019)",
      fill: "#AEB2BD"
    }), /*#__PURE__*/_jsx("rect", {
      x: "50.343",
      y: "42.687",
      width: "33.56",
      height: "15.915",
      rx: "7.958",
      transform: "rotate(11.655 50.343 42.687)",
      fill: "#292C33"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "60.075",
      cy: "52.123",
      r: "3.476",
      transform: "rotate(11.655 60.075 52.123)",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M49.69 72.335c-1.938 2.605-10.927-3.43-16.12-10.732-4.637-6.521 3.116-14.784 9.4-10.298 6.283 4.486 8.916 18.079 6.72 21.03z",
      fill: "#C6CAD2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M76.537 56.019c-.388 1.88-1.506 1.355-3.386.967-1.88-.388-3.81-.491-3.422-2.371a3.476 3.476 0 016.808 1.404z",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("rect", {
      x: "16.346",
      y: "61.13",
      width: "74.671",
      height: "32.387",
      rx: "3.017",
      fill: "#DBDEE6"
    }), /*#__PURE__*/_jsx("ellipse", {
      cx: "37.491",
      cy: "53.948",
      rx: "4.203",
      ry: "1.764",
      transform: "rotate(-31.181 37.49 53.948)",
      fill: "#292C33"
    }), /*#__PURE__*/_jsx("rect", {
      x: "1.639",
      y: "52.641",
      width: "83.549",
      height: "12.872",
      rx: "3.017",
      transform: "rotate(-20.1 1.64 52.641)",
      fill: "#DBDEE6"
    }), /*#__PURE__*/_jsx("rect", {
      x: "89.218",
      y: "43.986",
      width: "7.197",
      height: "2.699",
      rx: "1.349",
      transform: "rotate(-14.06 89.218 43.986)",
      fill: "#DBDEE6"
    }), /*#__PURE__*/_jsx("rect", {
      x: "85.286",
      y: "40.984",
      width: "7.197",
      height: "2.699",
      rx: "1.349",
      transform: "rotate(-48.322 85.286 40.984)",
      fill: "#DBDEE6"
    }), /*#__PURE__*/_jsx("rect", {
      opacity: ".5",
      x: "49.633",
      y: "61.13",
      width: "8.097",
      height: "32.387",
      fill: "#F2F4F7"
    }), /*#__PURE__*/_jsx("rect", {
      opacity: ".5",
      x: "16.346",
      y: "79.123",
      width: "8.097",
      height: "74.671",
      transform: "rotate(-90 16.346 79.123)",
      fill: "#F2F4F7"
    }), /*#__PURE__*/_jsx("rect", {
      opacity: ".5",
      x: "37.038",
      y: "39.614",
      width: "8.097",
      height: "12.808",
      transform: "rotate(-20.042 37.038 39.614)",
      fill: "#F2F4F7"
    }), /*#__PURE__*/_jsx("rect", {
      x: "89.53",
      y: "48.535",
      width: "7.197",
      height: "2.699",
      rx: "1.349",
      transform: "rotate(26.678 89.53 48.535)",
      fill: "#DBDEE6"
    }), /*#__PURE__*/_jsx("rect", {
      x: "19.945",
      y: "82.721",
      width: "13.495",
      height: "8.097",
      rx: "1.799",
      fill: "#F2F4F7"
    }), /*#__PURE__*/_jsx("rect", {
      x: "22.644",
      y: "85.42",
      width: "6.298",
      height: ".9",
      rx: ".45",
      fill: "#AEB2BD"
    }), /*#__PURE__*/_jsx("rect", {
      x: "22.644",
      y: "87.22",
      width: "4.498",
      height: ".9",
      rx: ".45",
      fill: "#AEB2BD"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.146 18.163a6.983 6.983 0 01-9.168-9.646 8.254 8.254 0 001.045 16.439 8.255 8.255 0 008.123-6.793z",
      fill: "#DBDEE6"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M33.44 9.85a3.599 3.599 0 01-3.599 3.599 3.599 3.599 0 013.599 3.59 3.599 3.599 0 013.598-3.59 3.599 3.599 0 01-3.598-3.598z",
      fill: "#DBDEE6"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M49.634 20.691a3.599 3.599 0 003.598 3.553 3.599 3.599 0 00-3.599 3.589 3.599 3.599 0 00-3.555-3.588 3.599 3.599 0 003.556-3.554z",
      fill: "#DBDEE6"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.945 30.542a3.599 3.599 0 003.599-3.598 3.599 3.599 0 003.598 3.599 3.599 3.599 0 00-3.598 3.59 3.599 3.599 0 00-3.599-3.59z",
      fill: "#DBDEE6"
    })]
  }));
};
export default IconBotNoData100pxBoldLightS;